/* eslint-disable prettier/prettier */
import styled from 'styled-components';
import { mediaMaxWidth } from '../../../theme/mediaQueriesTemplates';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

interface IStripeFieldProps {
  error?: boolean;
}

export const StripeField = styled.div`
  border: ${(props: IStripeFieldProps) =>
    props.error ? '1px solid #f2008c' : '1px solid #d8d8d8'};
  border-radius: 4px;
  padding: 5px 10px;
  margin: 5px 0 20px 0;
  position: relative;
`;

export const StripeFieldsGroup = styled.div`
  display: flex;

  ${StripeField} {
    flex: 1;
  }

  ${StripeField}:nth-child (1) {
    margin-right: 5px;
  }

  ${StripeField}:nth-child (2) {
    margin-left: 5px;
  }
`;

export const Error = styled.div`
  position: absolute;
  color: #f2008c;
  font-size: 0.7em;
  width: 100%;
  left: 0;
  top: 28px;
  text-align: center;
  font-weight: 600;
`;

export const Terms = styled.div`
  position: relative;
  display: flex;
  height: 90px;
  margin: 25px 0 5px 0;

  ${mediaMaxWidth.tablet} {
    margin: 15px 0 5px 0;
  }

  ${mediaMaxWidth.phone} {
    margin: 25px 0 15px 0;
  }
`;

export const Label = styled.label`
  color: #9c9c9c;
  font-weight: 400;
  font-size: 0.75em;
  margin-bottom: 0;

  ${mediaMaxWidth.tablet} {
    font-size: 0.72em;
    padding: 0 10px 0 30px !important;
  }
`;

export const Checkbox = styled.input`
  position: absolute;
  opacity: 0;

  & + ${Label} {
    position: relative;
    cursor: pointer;
    padding: 0 0 0 30px;
    text-align: justify;
  }

  & + ${Label}:before {
    content: '';
    margin-right: 10px;
    display: inline-block;
    vertical-align: text-top;
    width: 20px;
    height: 20px;
    background: white;
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    position: absolute;
    left: 0px;
    top: 3px;
  }

  &:hover + ${Label}:before {
    background: #9c9c9c;
    border: 2px solid #9c9c9c;
  }

  &:checked + ${Label}:before {
    background: #f2008c;
    border: 2px solid #f2008c;
  }

  &:checked + ${Label}:after {
    content: '';
    position: absolute;
    left: 5px;
    top: 12px;
    background: white;
    width: 2px;
    height: 2px;
    box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white,
      4px -6px 0 white, 4px -8px 0 white;
    transform: rotate(45deg);
  }
`;

export const SubmitButtonWrapper = styled.div`
  color: #9c9c9c;
  display: flex;
  justify-content: center;
`;

export const FakeButton = styled.div`
  font-weight: bold;
  background: #9c9c9c;
  border: 1px solid #9c9c9c;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  color: #fff;
  padding: 10px 12px;
  font-family: Raleway;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  cursor: not-allowed;
`;
